import MailIcon from '../../assets/icons/mail.svg?react';
import PlusIcon from '../../assets/icons/plus.svg?react';
import TeamsIcon from '../../assets/icons/teams.svg?react';
import { MobileListItemConfig } from '../../components/data-display/ResponsiveDataView';
import { ChannelType, NotificationChannel } from '../../gql/generated';

interface ChannelListItemMobileProps {
  channel: NotificationChannel;
  config: MobileListItemConfig<NotificationChannel>;
}

export function ChannelListItemMobile({
  channel,
  config,
}: ChannelListItemMobileProps) {
  const { onClick } = config;

  const getChannelIcon = () => {
    switch (channel.channelType) {
      case ChannelType.Teams:
        return <TeamsIcon className='text-primary h-5 w-5' />;
      case ChannelType.Email:
        return <MailIcon className='text-primary h-5 w-5' />;
      case ChannelType.Grouped:
        return <PlusIcon className='text-primary h-5 w-5' />;
    }
  };

  return (
    <div
      className='flex cursor-pointer items-center gap-4 p-4 transition-colors
        hover:bg-gray-50 active:bg-gray-100'
      onClick={() => onClick?.(channel)}
    >
      <div className='flex h-10 w-10 items-center justify-center'>
        {getChannelIcon()}
      </div>
      <div className='min-w-0 flex-1'>
        <h3 className='text-focus mb-1 truncate text-base font-semibold'>
          {channel.name}
        </h3>

        <p className='truncate text-sm text-gray-600'>
          <span className='font-medium'>Type:</span> {channel.channelType}
        </p>
      </div>
    </div>
  );
}
